import React from 'react';
import { View, TouchableWithoutFeedback, Animated } from 'react-native';

import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './Overlay.Styles';

const Overlay = ({ isVisible, onPress, animation }) => {
  return isVisible ? (
    <Animated.View
      style={[styles.backdrop, animation]}
      testID={FrameworkTestKeys.trayOverlayAnimatedView}
    >
      {/*
        onPress is not passed directly as a prop and it is used as an inline function because the toggleModal(the onPress passed) will be invoked
        the touch event from the native side causing weird behaviour, so we invoke it manually with no parameter.
      */}
      <TouchableWithoutFeedback onPress={() => onPress()} testID={FrameworkTestKeys.trayOverlayTWF}>
        <View style={styles.innerBackOverlay} testID={FrameworkTestKeys.trayOverlayView} />
      </TouchableWithoutFeedback>
    </Animated.View>
  ) : null;
};

Overlay.propTypes = {
  isVisible: PropTypes.bool,
  onPress: PropTypes.func,
  animation: PropTypes.object,
};

export default Overlay;
